module.exports = __webpack_public_path__ + "assets/img/yd1.2eb153f8.png";